import { z } from 'zod';
/**
 * The industries a website can choose (`product/business-rules.md`, Industry
 * and guardrail sets). Each has its own guardrail set. The PostgreSQL
 * `industry` enum is built from this same array
 * (`patterns/db-schema-conventions.md`, 5); an enum value is only ever added,
 * never renamed or removed.
 */
export const INDUSTRIES = [
    'health',
    'legal',
    'financial',
    'real_estate',
    'education',
    'other',
];
export const industrySchema = z.enum(INDUSTRIES);
/** How an industry is named in the dashboard and the admin panel. */
export const INDUSTRY_LABELS = {
    health: 'Clinics and healthcare',
    legal: 'Law firms',
    financial: 'Financial and insurance advisers',
    real_estate: 'Estate agencies',
    education: 'Education and training',
    other: 'Other',
};
//# sourceMappingURL=industry.js.map